import React from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import './Dialogs.scss';

interface ErrorDialogProps {
  isOpen: boolean;
  message: string;
  title?: string;
  onClose: () => void;
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({ isOpen, message, title = 'Error', onClose }) => {
  if (!isOpen) return null;

  return (
    <Dialog title={title} onClose={onClose} width={400}>
      <div className="offboard-dialog-content">
        <p className="offboard-dialog-text">{message}</p>
        <div className="offboard-button-container error-dialog-button-container">
          <button className="dashboard-button offboard-dialog-button primary-button" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default ErrorDialog;
